$(document).ready(function () {
  // Initially show the first tab content and hide the rest
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide(); // Hide all images (tab contents)
  $(".tab-content:first").show(); // Show the first tab image

  // Hide all li-content except the first one and toggle icons accordingly
  $("#tabs-nav li").each(function (index) {
    if (index !== 0) {
      $(this).find(".li-content").hide(); // Hide text inside li-content except the first
      $(this).find(".icon__minus").hide(); // Show plus icon by default
    } else {
      $(this).find(".icon__plus").hide(); // Hide plus icon for the first active tab
    }
  });

  // Click function for tabs
  $("#tabs-nav li").click(function () {
    var activeTab = $(this).find("a").attr("href");

    // Check if the clicked li is already active
    if ($(this).hasClass("active")) {
      // If active, collapse the text content but keep the image visible
      $(this).removeClass("active");
      $(this).find(".li-content").slideUp(); // Hide the li-content (text)
      $(this).find(".icon__minus").hide(); // Hide minus icon
      $(this).find(".icon__plus").show(); // Show plus icon

      // The image stays visible even if the text is collapsed
    } else {
      // Remove active class from all tabs and hide all text content
      $("#tabs-nav li").removeClass("active");
      $(".li-content").slideUp(); // Hide all li-content (text)
      $(".icon__minus").hide(); // Hide all minus icons
      $(".icon__plus").show(); // Show all plus icons

      // Add active class to clicked li
      $(this).addClass("active");

      // Show the text for the active li
      $(this).find(".li-content").slideDown(); // Show text in li-content

      // Toggle icons
      $(this).find(".icon__plus").hide(); // Hide plus icon for active tab
      $(this).find(".icon__minus").show(); // Show minus icon for active tab
    }

    // Hide all tab contents (images) first, then show the correct one
    $(".tab-content").hide(); // Hide all images
    $(activeTab).fadeIn(); // Show the selected tab image

    return false; // Prevent default anchor click behavior
  });

  // Keep the image of the first tab visible on load
  $(".tab-content:first").show();
});
